export default __webpack_public_path__ + "static/media/plus_green.943cbb95.svg";